import { Component, OnInit } from "@angular/core";
import { NavController } from "@ionic/angular";
import { Article } from "./_models/article";
import { ArticlesService } from "./_services/articles.service";
import { AuthService } from "./_services/auth.service";
import { StorageService } from "./_services/storage.service";

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {

  public menus: Article[] = [];

  constructor(
    public authService: AuthService,
    public articlesService: ArticlesService,
    public storageService: StorageService,
    public navController: NavController,
  ) {

  }

  ngOnInit() {
    this.authService.refreshToken()
      .subscribe(() => {
        this.articlesService.menu()
          .subscribe(menu => this.menus = menu);
      });
  }

  returnUrl(article: Article) {
    if (article.slug == 'articles') {
      return '/' + article.slug;
    } else {
      if (article.fullview) {
        return '/fullview/' + article.id;
      } else {
        return '/articles/' + article.id;
      }
    }
  }

  goToPage(article: Article) {
    this.navController.navigateForward(this.returnUrl(article));
  }

}
